import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

type ResetPasswordRequest = {
  email: string;
  password: string;
  new_password: string;
  new_password_confirmation: string;
};
type ResetPasswordResponse = {
  is_first_login: boolean;
  session: string;
  two_factor_enabled: boolean;
};
type ResetPasswordErrorResponse = {
  email?: string[];
  password?: string[];
  new_password?: string[];
  new_password_confirmation?: string[];
  message?: string[];
};

export const firstResetPasswordApiClient = {
  resetPassword: async (
    params: ResetPasswordRequest,
  ): Promise<ApiResult<ResetPasswordResponse, ResetPasswordErrorResponse>> => {
    return await axiosClient.put('/tenant/auth/first-reset-password', params);
  },
};
